import { CHARTAPI } from './TRADEAPIKEYS'

export const VERSION = process.env.REACT_APP_VERSION || '6.0.0' // 배포시 수정

// 동적 브랜드 설정을 우선 사용하는 COINHIDE 
const getCoinHide = () => {
	try {
		const brandConfig = (window as any).BRAND_CONFIG || {}
		const envValue = brandConfig.REACT_APP_COINHIDE || process.env.REACT_APP_COINHIDE
		return envValue === 'true' || envValue === true
	} catch {
		return process.env.REACT_APP_COINHIDE === 'true'
	}
}

export const COINHIDE = getCoinHide() // 코인기능사용여부
export const ENGONLY = process.env.REACT_APP_ENGLISH || false // 코인기능사용여부

export const NAME = process.env.REACT_APP_NAME

// 동적 브랜드 설정을 우선 사용하는 함수들
const getBrandConfig = () => {
	try {
		return (window as any).BRAND_CONFIG || {}
	} catch {
		return {}
	}
}

// 동적 API URL 함수들로 변경
export const getApiUrl = () => getBrandConfig().REACT_APP_API_URL || process.env.REACT_APP_API_URL
export const getCoinApiUrl = () => getBrandConfig().REACT_APP_COINAPI_URL || process.env.REACT_APP_COINAPI_URL
export const getTradeSocketUrl = () => getBrandConfig().REACT_APP_SOCKET_URL || process.env.REACT_APP_SOCKET_URL
export const getChartSocketUrl = () => getBrandConfig().REACT_APP_CHARTSOCKET_URL || process.env.REACT_APP_CHARTSOCKET_URL || ''
export const getUserSocketUrl = () => getBrandConfig().REACT_APP_USERSOCKET_URL || process.env.REACT_APP_USERSOCKET_URL || ''
export const getPartnerUrl = () => getBrandConfig().REACT_APP_IMAGEAPI_URL || process.env.REACT_APP_IMAGEAPI_URL

// 하위 호환성을 위한 기존 export (deprecated)
export const API_URL = getApiUrl()
export const API_COINURL = getCoinApiUrl()
export const TRADE_SOCKET_URL = getTradeSocketUrl()
export const CHART_SOCKET_URL = getChartSocketUrl()
export const USER_SOCKET_URL = getUserSocketUrl()
export const PARTNERURL = getPartnerUrl()
/////////////////////////////////////////////////////////////////////

export const USERINFO = '/user/my/info' // 사용자 정보
export const MYSETTINGS = '/user/my/settings' // 내 설정
export const MYBALANCE = '/user/my/balance' // 내 자산
export const MYLOCKBALANCE = '/user/my/lockbalance' // 내 자산
export const POPUP = '/popup/active' // popup
export const MYTRADESETTINGS = '/user/my/tradesetting' // 내 트레이딩설정
export const CHART_HISTORY = CHARTAPI + '/history'

export const TRANSFER = '/user/my/transfer'

export const EXCHANGESETTINGS = '/exchanges' // 거래쌍 설정
export const ORDERBOOK = '/trade/orderbook' // 오더북
export const CANCELORDER = '/trade/cancel' // 주문취소

export const TRADELIST = '/trade/tradelist' // 주문취소

//COIN
export const COIN_URL: any = process.env.REACT_APP_COIN_URL

export const STATUS = '/trade/status'
